import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'la-next-button',
  templateUrl: './next-button.component.html',
  styleUrl: './next-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule, MatButtonModule, MatTooltipModule, MatIconModule],
})
export class NextButtonComponent {
  @Input() disabled = false;
  @Input() tooltipForEnabled?: string;
  @Input() tooltipForDisabled?: string;

  @Output() action = new EventEmitter<void>();

  get hasTooltip(): boolean {
    return !!this.tooltipForDisabled || !!this.tooltipForEnabled;
  }

  get tooltip(): string | undefined {
    return this.disabled ? this.tooltipForDisabled : this.tooltipForEnabled;
  }
}
